import React from 'react';

interface PopupHeaderProps {
  children: React.ReactNode;
}

const PopupHeader: React.FC<PopupHeaderProps> = ({ children }) => (
  <div className="popup-header">
    <h2>{children}</h2>
  </div>
);

export default PopupHeader;
